// extracted by mini-css-extract-plugin
module.exports = {"proWeekCover":"ProAccCover-module--proWeekCover--yOSaI","coverTitleContainer":"ProAccCover-module--coverTitleContainer--3RA65","coverTitle":"ProAccCover-module--coverTitle--39VL8"};